import React, { useContext } from 'react';
import { EntityDefinition } from 'types';
import EditContext from './EditContext';
import { RouteComponentProps, withRouter } from 'react-router-dom';

export interface RenderEditToListingActionProps extends RouteComponentProps<any> {
	lastLocationPathAndQuery: string;
	entityDefinition: EntityDefinition;
}

interface EditToListingActionProps extends RouteComponentProps<any> {
	children: (props: RenderEditToListingActionProps) => React.ReactElement;
}

/**
 * Cancel button for edit pages, which returns you back to where you came from
 *
 */
function EditToListingAction(props: EditToListingActionProps) {
	const {
		lastLocation,
		entityDefinition: { baseRoute },
		entityDefinition,
	} = useContext(EditContext);

	const { children, location, history, match } = props;
	const lastLocationPathAndQuery =
		lastLocation === null || lastLocation.pathname === location.pathname
			? baseRoute
			: lastLocation.pathname + lastLocation.search;

	return children({ lastLocationPathAndQuery, entityDefinition, location, history, match });
}

export default withRouter(EditToListingAction);
